module.exports = __webpack_public_path__ + "static/media/ThumbnailStill01.3628991d.png";